import { Route } from '@angular/router';
import { AuthGuard, portalTranslationGuard } from '@libs/vc-core-lib';
import { LandingComponent } from './landing/landing.component';
import { MainViewComponent } from './main-view/main-view.component';
import { SecureEdgePublicWebsiteComponent } from './secure-edge-public-website/secure-edge-public-website.component';

export const coreAppRoutes: Route[] = [
    {
        path: '',
        component: MainViewComponent,
        canActivateChild: [AuthGuard, portalTranslationGuard],
        children: [
            { path: 'dashboard', component: LandingComponent },
            {
                path: 'account',
                loadChildren: () =>
                    import('./settings/account-settings/account-settings.routes').then((m) => m.accountSettingsRoutes),
            },
            {
                path: 'finding',
                loadChildren: () =>
                    import('@apps/vc-findings-ui/app/findings-app.routes').then((m) => m.findingsAppRoutes),
            },
            {
                path: 'event',
                loadChildren: () => import('@apps/vc-events-ui/app/events-app.routes').then((m) => m.eventsAppRoutes),
            },
            {
                path: 'asset',
                loadChildren: () => import('@apps/vc-assets-ui/app/assets-app.routes').then((m) => m.assetsAppRoutes),
            },
            {
                path: 'file-browser',
                loadChildren: () =>
                    import('@apps/vc-file-browser-ui/app/file-browser.routes').then((m) => m.fileBrowserRoutes),
            },
            {
                path: 'notifications-settings',
                loadChildren: () =>
                    import('./settings/notifications-settings/notifications-settings.routes').then(
                        (m) => m.notificationsSettingsRoutes
                    ),
            },
            {
                path: 'notification-history',
                loadChildren: () =>
                    import('./settings/notification-history/notification-history.routes').then(
                        (m) => m.notificationHistoryRoutes
                    ),
            },
            {
                path: 'assessment',
                loadChildren: () => import('@apps/vc-assessment-ui/app/app.routes').then((m) => m.assessmentRoutes),
            },
            {
                path: 'security-operations',
                loadChildren: () =>
                    import('@apps/vc-security-operation-ui/app/security-operation.routes').then(
                        (m) => m.securityOperationRoutes
                    ),
            },
            {
                path: 'admin',
                loadChildren: () => import('@apps/vc-admin-ui/app/app.routes').then((m) => m.adminRoutes),
            },
            {
                path: 'scan',
                loadChildren: () => import('@apps/vc-scan-ui/app/app.routes').then((m) => m.scanRoutes),
            },
            {
                path: 'mss',
                loadChildren: () => import('@apps/vc-mss-ui/app/app.routes').then((m) => m.mssRoutes),
            },
            {
                path: 'support-mss',
                loadChildren: () => import('@apps/vc-mss-ui/app/mss-support.routes').then((m) => m.mssSupportRoutes),
            },
            {
                path: 'secure-edge',
                loadChildren: () => import('@apps/vc-mss-ui/app/secure-edge.routes').then((m) => m.secureEdgeRoutes),
            },
            {
                path: 'endpoints',
                loadChildren: () => import('@apps/vc-endpoint-ui/app/app.routes').then((m) => m.endpointRoutes),
            },
            {
                path: 'marketplace',
                loadChildren: () => import('@apps/vc-marketplace-ui/app/app.routes').then((m) => m.marketplaceRoutes),
            },
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'prefix',
            },
        ],
    },
    { path: 'secureedge', component: SecureEdgePublicWebsiteComponent },
    {
        path: 'setup-mfa',
        loadComponent: () =>
            import('@apps/vc-login-ui/app/components/multi-factor/multi-factor.component').then(
                (m) => m.MultiFactorComponent
            ),
    },
    {
        path: '',
        loadChildren: () => import('@apps/vc-login-ui/app/login-app.routes').then((m) => m.loginAppRoutes),
    },
    { path: '**', redirectTo: '' },
];
